import type { Headers, Params, Customer } from './types'

const CdpService = class {
  headers: Headers
  cdpUrl: Params['cdpUrl']
  apiFetch: Params['apiFetch']

  constructor (params: Params) {
    this.apiFetch = params.apiFetch
    this.cdpUrl = params.cdpUrl
    this.headers = {
      'x-application-id': params.xApplicationId,
      'x-api-key': params.xApiKey,
      'Content-Type': 'application/json'
    }
  }

  async getCustomer (id: string) {
    try {
      const endpoint = `${this.cdpUrl}?id=${id}`
      const result = await this.apiFetch(endpoint, {
        method: 'GET',
        headers: {
          ...this.headers
        }
      })

      return result
    } catch (error: any) {
      throw error.data
    }
  }

  async updateCustomer (cdpId: string, data: Customer) {
    try {
      const endpoint = `${this.cdpUrl}/${cdpId}`
      const result = await this.apiFetch(endpoint, {
        method: 'PUT',
        headers: {
          ...this.headers
        },
        body: JSON.stringify(data)
      })

      return result
    } catch (error: any) {
      throw error.data
    }
  }

  async getCustomerByPhone (phone: string, retries = 5) {
    try {
      const endpoint = `${this.cdpUrl}?phone=${phone}`
      const result = await this.apiFetch(endpoint, {
        method: 'GET',
        headers: {
          ...this.headers
        },
        retryStatusCodes: [500, 404],
        retry: retries,
        retryDelay: 1000
      })

      return result
    } catch (error: any) {
      throw error.data
    }
  }

  async getCustomerByEmail (email: string, retries = 1) {
    try {
      const endpoint = `${this.cdpUrl}?email=${email}`
      const result = await this.apiFetch(endpoint, {
        method: 'GET',
        headers: {
          ...this.headers
        },
        retryStatusCodes: [500, 404],
        retry: retries,
        retryDelay: 1000
      })

      return result
    } catch (error: any) {
      throw error.data
    }
  }

  async createCustomer (data: Customer) {
    const endpoint = `${this.cdpUrl}`
    const result = await this.apiFetch(endpoint, {
      method: 'POST',
      headers: {
        ...this.headers
      },
      body: JSON.stringify(data)
    })

    return result
  }
}

export default CdpService
